<template>
  <b-modal
    id="modal-reason"
    ref="my-reason"
    cancel-variant="outline-secondary"
    :ok-title="$t('DEBTIA_ADD_REASON')"
    :title="$t('DEBTIA_ADD_CASE_REASON_TITLE')"
    cancel-title="Close"
    centered
    size="md"
    @ok.prevent="addCaseReason"
    @close="handleClose"
    @hide="handleClose"
  >
    <b-overlay
      id="overlay-background"
      :show="loader"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-alert
        v-if="alertError"
        variant="danger"
        show
      >
        <div
          v-for="(error, index) in alertError"
          :key="index"
          class="alert-body"
        >
          <span>{{ error }}</span>
        </div>
      </b-alert>
      <validation-observer
        ref="simpleRules"
      >
        <b-form @submit.prevent>

          <b-row>
            <b-col>
              <b-form-group
                class="mb-"
                :label="$t('DEBTIA_CASE_REASON_TITLE')"
                label-for="case-reason-title"
              >
                <validation-provider
                  #default="{ errors }"
                  name="case reason"
                  rules="required"
                >
                  <b-form-input
                    id="case-reason-title"
                    v-model="title"
                    class="mt-1"
                    type="text"
                    @keyup.enter="addCaseReason"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BRow, BCol, BForm, BFormGroup, BOverlay, BModal, BFormInput, BAlert,
} from 'bootstrap-vue'
import axios from '@axios'
import i18n from '@/libs/i18n'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import constants from '@/app-configs/constants'

export default {
  name: 'AddCaseReasons',
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BOverlay,
    BModal,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    BAlert,
  },
  props: {
    reloadMethod: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      loader: false,
      title: '',
      reasonOptions: [],
      alertError: '',
    }
  },
  methods: {
    addCaseReason() {
      this.loader = true
      this.$refs.simpleRules.validate().then(success => {
        if (!success) {
          this.loader = false
          return
        }

        const url = `${constants.baseUrl}/reasons`
        axios.post(url, { title: this.title }).then(response => {
          if (response.status === 200) {
            this.loader = false
            this.$refs['my-reason'].hide()
            this.title = ''
            this.reloadMethod()
            this.$swal({
              icon: 'success',
              title: i18n.t('DEBTIA_SUCCESS'),
              text: i18n.t('DEBTIA_CASE_REASON_SWAL_SUCCESS'),
              customClass: {
                confirmButton: 'btn btn-primary',
              },
            })
          }
        }).catch(error => {
          this.loader = false
          this.alertError = error.response.data.message
        })
      })
    },
    handleClose(evt) {
      if (evt.trigger !== 'ok') {
        this.resetModal()
      }
    },
    resetModal() {
      this.title = ''
      this.alertError = ''
    },
  },
}
</script>
